import {Action, Dispatch} from 'redux';
import {ADMIN_EXCHANGES} from '../../../@crema/services/ApiConfig';
import {showError} from '../Common';
import {ApiActionCall, ApiActionTypes} from '../Api';
import {
  FETCH_EXCHANGE_STATUS,
  FETCH_EXCHANGE_STATUS_SUCCESS,
  FETCH_EXCHANGE_STATUS_ERROR,
  ExchangeStatusActions,
} from '../../../types/actions/Exchanges/ExchangeStatus.actions';
import {IExchangeStatus} from '../../../types/models/ExchangeStatus';
import {logger} from '../../../shared/logger';

export const fetchExchangeStatus = (exchange: string) => async (
  dispatch: Dispatch<ApiActionCall | ExchangeStatusActions>,
) => {
  dispatch({type: FETCH_EXCHANGE_STATUS});

  const onSuccess = (payload: IExchangeStatus) => ({
    type: FETCH_EXCHANGE_STATUS_SUCCESS,
    payload: {
      ...payload,
      slug: exchange,
    },
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_EXCHANGE_STATUS_ERROR});
    dispatch(showError('Failed to fetch exchange status.'));
  };
  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: ADMIN_EXCHANGES + exchange,
      method: 'GET',
      label: 'Fetch exchange status',
      onSuccess,
      onFailure,
    },
  });
};
